import React from 'react'
import PropTypes from 'prop-types'
import { isMobile } from 'react-device-detect'
import styled from 'styled-components'
import { greys } from 'assets/themes/theme-default'

import { DistributorCard } from './DistributorCard'

const ListDiv = styled.div`
  height: ${!isMobile && '857px'};
  overflow-y: ${!isMobile && 'auto'};
  padding-right: 2px;
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-track {
    background: ${greys.light4};
  }
  ::-webkit-scrollbar-thumb {
    background: ${greys.light1};
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${greys.dark4};
  }
`
const DistributorList = props => {
  const { pointsOfSalesList, handleChangePointOfSales, selectedPointOfSale } = props

  return (
    <ListDiv>
      {pointsOfSalesList.map((pointOfSales, i) => (
        <DistributorCard
          pointOfSales={pointOfSales}
          selectedPointOfSale={selectedPointOfSale}
          handleChangePointOfSales={handleChangePointOfSales}
          count={i}
        />
      ))}
    </ListDiv>
  )
}

DistributorList.propTypes = {
  pointsOfSalesList: PropTypes.shape().isRequired,
  handleChangePointOfSales: PropTypes.func.isRequired,
  selectedPointOfSale: PropTypes.number.isRequired
}
export default DistributorList
